export default "<div\n  *ngIf=\"staticContent\"\n  class=\"seo-content\"\n  [innerHtml]=\"staticContent | safeHtml\"\n></div>"